import { Flex, HStack } from '@chakra-ui/react';

import { IndividualRole } from '@aslanpay/portal-common-lib';

import ProfileField from 'app/components/UI/ProfileField';
import ProfileSection from 'app/components/UI/ProfileSection';

import { Role } from 'app/constants/individual';

import { MyProfileViewProps } from './types';

function MyProfileView({ admin, company }: MyProfileViewProps) {
  return (
    <Flex mt="20px" gap="60px" alignItems="flex-start">
      <Flex flexDirection="column" gap="40px" flexGrow={1} maxW="492px">
        <ProfileSection title="My IDs">
          <ProfileField label="Aslan ID" value={admin?.friendlyId} />
        </ProfileSection>
        {company && (
          <ProfileSection title="User level">
            <ProfileField label="My role" value={Role[admin?.role as IndividualRole]} />
            <ProfileField label="Company name" value={company?.name} />
          </ProfileSection>
        )}
      </Flex>
      <ProfileSection title="General details">
        <HStack spacing="20px">
          <ProfileField label="First name" value={admin?.firstName} />
          <ProfileField label="Last name" value={admin?.lastName} />
        </HStack>
        <ProfileField label="Email" value={admin?.email} />
        <ProfileField label="Phone number" value={admin?.phoneNumber} />
      </ProfileSection>
    </Flex>
  );
}

export default MyProfileView;
